import { backEndAxios, restAxios } from './httpClient';
import { normalizeLearnMoreUrl } from '../helpers/learnMoreUrl';

export const getSettings = () => {
	return backEndAxios.get('/centralBackend/v2/settings/getSettings');
};

export const getUpgradeToOsSettings = () => {
	return restAxios.get('/system/settings/upgrade-to-os5');
};

export const patchUpgradeToOsSettings = (payload) => {
	return restAxios.patch('/system/settings/upgrade-to-os5', payload);
};

export const getPartnerPreviewSettings = () => {
	return restAxios.get('/system/settings/preview-program');
};

// The service owns the wire shape: the key is always present ('' when the admin cleared the field),
// otherwise the PATCH would be a no-op and the old link would stay live on the Dashboard.
export const patchPartnerPreviewSettings = (learnMoreUrl) => {
	return restAxios.patch('/system/settings/preview-program', {
		partnerPreviewLearnMoreUrl: normalizeLearnMoreUrl(learnMoreUrl)
	});
};
